import React from 'react';
import PropTypes from 'prop-types';
import { SectionNav, SectionNavList, SectionNavItem } from 'components/section-nav';
import { getProductsUrl } from 'constants/common';

function ProductsSubNav({ location }) {
  const { rentersInsuranceUrl, idTheftProtectionUrl, petInsuranceUrl } = getProductsUrl();
  return (
    <SectionNav>
      <SectionNavList location={location}>
        <SectionNavItem to={rentersInsuranceUrl}>Renters Insurance</SectionNavItem>
        <SectionNavItem to={idTheftProtectionUrl}>Identity Theft Protection</SectionNavItem>
        <SectionNavItem to={petInsuranceUrl}>Pet Insurance</SectionNavItem>
      </SectionNavList>
    </SectionNav>
  );
}

ProductsSubNav.propTypes = {
  location: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

ProductsSubNav.defaultProps = {
  location: null,
};

export default ProductsSubNav;
